import './Skeleton.css';

export interface SkeletonProps {
  width?: string | number;
  height?: string | number;
}

/** Yüklenme durumunda gerçek içeriğin yerini tutan shimmer bar. */
export function Skeleton({ width = '100%', height = 16 }: SkeletonProps) {
  return (
    <span
      className="skeleton"
      style={{
        width: typeof width === 'number' ? `${width}px` : width,
        height: typeof height === 'number' ? `${height}px` : height,
      }}
    />
  );
}
